import { Link } from 'react-router-dom';
import { Section, Media, Video, RuleList } from '../ui';
import { FLIGHT_CAPABILITIES, STATS } from '../content';

export default function Flight() {
  return (
    <main>
      <Section lg>
        <div className="split">
          <div>
            <Link className="eyebrow" to="/services" style={{ textTransform: 'uppercase' }}>
              Services &#65295; Flight
            </Link>
            <h1 className="h-page" style={{ fontSize: 'clamp(36px, 5vw, 64px)' }}>
              Flight Solutions
            </h1>
            <p className="lede" style={{ maxWidth: '52ch' }}>
              Professional UAS operations built around your mission, your data requirements, and
              your workflow. From routine image capture to advanced BVLOS inspection operations,
              Wanda provides safe, repeatable aerial data collection — without requiring customers
              to purchase additional analytics or AI services.
            </p>
          </div>
          <Media
            src="/assets/flight-crew.jpg"
            alt="Certified pilot in high-visibility gear operating an inspection drone on site"
            ratio="16x10"
            caption="Crew and aircraft on site"
            priority
          />
        </div>
      </Section>

      <Section>
        <h2 className="h-sub" style={{ marginBottom: 36 }}>
          Flight capabilities
        </h2>
        <div className="grid-rule" style={{ '--min': '240px' }}>
          {FLIGHT_CAPABILITIES.map((c) => (
            <div className="card" key={c.t} style={{ padding: 28 }}>
              <h3 style={{ margin: '0 0 10px', fontSize: 16 }}>{c.t}</h3>
              <p className="body body--sm">{c.d}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section alt>
        <div className="split" style={{ alignItems: 'start' }}>
          <div>
            <h2 className="h-sub" style={{ fontSize: 'clamp(22px, 2.4vw, 28px)', marginBottom: 24 }}>
              Deliverables
            </h2>
            <RuleList
              items={[
                'High-resolution stills and video',
                'Thermal and multispectral captures',
                'Orthomosaics and 3D reconstructions',
                'Findings reports with located defects'
              ]}
            />
          </div>
          <div>
            <h2 className="h-sub" style={{ fontSize: 'clamp(22px, 2.4vw, 28px)', marginBottom: 24 }}>
              Compliance
            </h2>
            <RuleList
              items={[
                'Part 107 certified pilots',
                'BVLOS waiver experience',
                'Documented safety and risk procedures',
                'Insured operations, per-site briefings'
              ]}
            />
          </div>
        </div>
      </Section>

      <Section>
        <div className="split">
          <div>
            <span className="eyebrow">Proven flight experience</span>
            <div className="grid-rule" style={{ '--min': '150px', marginTop: 24 }}>
              {STATS.map((s) => (
                <div className="card card--flat" key={s.l}>
                  <div className="stat__n" style={{ fontSize: 'clamp(30px, 3.4vw, 44px)' }}>
                    {s.n}
                  </div>
                  <div className="stat__l">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
          <Video
            src="/assets/flight-corridor.mp4"
            poster="/assets/flight-corridor-poster.jpg"
            alt="Aerial footage tracking along a road and utility corridor cut through forest"
            ratio="4x3"
            caption="Corridor capture — long-linear route"
          />
        </div>
      </Section>
    </main>
  );
}
